import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import FormInput from "../../../components/forms/Input";
import { saAlert } from "../../../helpers";
import { postDepartemen } from "../apis";

const Create = ({ mainUrl, onFetchData }) => {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});

  const history = useHistory();

  const handleChange = (e) => {
    setForm((prevState) => {
      return { ...prevState, [e.target.name]: e.target.value };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await postDepartemen(form);
      if (res.data && res.data.msg) {
        onFetchData();
        history.push(mainUrl);
        saAlert("success", res.data.msg);
      }
    } catch (err) {
      if (err.response && err.response.status === 422) {
        setErrors(err.response.data.errors);
      }
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        <h3>Tambah Data</h3>
        <FormInput
          label="nama"
          name="nama"
          onChange={handleChange}
          error={errors.nama}
        />
        <div className="btn-group">
          <button type="submit" className="btn btn-sm btn-success">
            Simpan
          </button>
          <Link type="button" className="btn btn-sm btn-secondary" to={mainUrl}>
            Tutup
          </Link>
        </div>
      </form>
    </>
  );
};

export default Create;
